module.exports = __webpack_public_path__ + "img/maze_heart_g.188af655.svg";